export const pythonAuthExample = `import requests
import json
import hmac
import hashlib
import os
from datetime import datetime
import uuid

# Authentication details
API_KEY = os.getenv("VENDOR_API_KEY")
WEBHOOK_SECRET = os.getenv("VENDOR_WEBHOOK_SECRET")

# Generate HMAC signature for the payload
def generate_signature(payload, secret):
    # Convert payload to JSON string with consistent ordering
    payload_string = json.dumps(payload, separators=(',', ':'), sort_keys=True)
    payload_bytes = payload_string.encode('utf-8')
    
    # Create signature
    signature = hmac.new(
        secret.encode('utf-8'),
        payload_bytes,
        hashlib.sha256
    ).hexdigest()
    
    return signature

# Example request with both authentication methods
def submit_data(test_data):
    endpoint = "https://app.reasonshield.com/api/v1/lis-webhook/vendor/submit-data"
    
    # Prepare request payload
    payload = {
        "vendor_id": os.getenv("VENDOR_ID"),
        "timestamp": datetime.now().isoformat(),
        "request_id": str(uuid.uuid4()),
        "test_data": test_data
    }
    
    # Generate signature for the payload
    signature = generate_signature(payload, WEBHOOK_SECRET)
    
    # Set up headers with BOTH authentication methods
    headers = {
        "Content-Type": "application/json",
        "Authorization": f"Bearer {API_KEY}",         # API Key Authentication
        "X-Vendor-Signature": signature               # Signature Verification
    }
    
    # Make the authenticated request
    response = requests.post(
        url=endpoint,
        json=payload,
        headers=headers
    )
    
    return response.json() if response.status_code == 200 else None`; 